import document from 'global/document';
import { CHANGE_PANELS_SIZES, FLIP_CURSOR } from 'actions';
import { dispatch, state } from '__common/store';
import { trunOffScaleTool } from './components/scale/scale';
import { isRMFamily } from '__common/constants/products';
import Events from '__common/modules/Events';
import { deployObstructionDrawing } from '__editor/panelsEditor/components/obstructions/obstructions';
import { displacePanels } from './components/panels/utils/panelsManagment';
import {
  LOAD_PANELS_FROM_HISTORY,
  REDO_HISTORY,
  RESET_PANELS_ARRAY_FOR_MOVEMENT,
  RESTORE_PANELS_FOR_NO_MOVEMENT,
  UNDO_HISTORY,
} from './actions';
import { RESET_CURRENT_MEASUREMENT } from '__editor/googleMapsRoofsSelector/components/measurementTool/measurementToolActions';
import { DEBUG } from 'debug';
/*
16: SHIFT
27: ESC
82: R
*/

let pressedKeys = [];

export const initKeyboard = (isRm: boolean) => {
  document.addEventListener('keyup', onKeyUp);
  document.addEventListener('keydown', onKeyDown);
  // eslint-disable-next-line no-console
  console.warn('[obsDbg] initKeyboard ADD dblclick.roofsSelectorStage', new Error().stack);
  Events.addEventListener('dblclick.roofsSelectorStage', () => {
    const { advanceRoofSelecting: { roofPoints } } = state();
    // const dblClick = true;
    // eslint-disable-next-line no-console
    console.warn('[obsDbg] dblclick.roofsSelectorStage FIRED roofPoints=', roofPoints.length);
    if (roofPoints.length > 1) {
      deployObstructionDrawing();
    }
  });
};

export const terminateKeyboard = () => {
  // eslint-disable-next-line no-console
  console.warn('[obsDbg] terminateKeyboard');
  pressedKeys = [];
  // Symmetric teardown of everything initKeyboard added. Previously this
  // removed 'keydown' twice (a typo for onKeyUp) and never removed the
  // dblclick.roofsSelectorStage listener — leaving a stale document-level
  // dblclick handler that fired deployObstructionDrawing() (→ ADD_OBSTRUCTION
  // → REMOVE_PANELS) when a user double-clicked to finalize a new roof in
  // UB-Lite, spuriously dirtying the project and reloading the BOM.
  document.removeEventListener('keyup', onKeyUp);
  document.removeEventListener('keydown', onKeyDown);
  Events.removeEventListener('dblclick.roofsSelectorStage');
};

export const isShiftPressed = () => {
  return pressedKeys[16];
};

function onKeyUp(key) {
  pressedKeys[key.keyCode] = false;
  pressedKeys = pressedKeys.map(keys => keys);
}

function isEditableElement(target) {
  if (!target) {
    return false;
  }

  const tagName = target.tagName && target.tagName.toLowerCase();

  return target.isContentEditable || tagName === 'input' || tagName === 'textarea' || tagName === 'select';
}

function loadPanelsFromCurrentHistoryIndex() {
  const { history } = state();
  const panels = history.panelsSnapshot[history.index];

  if (panels) {
    dispatch(LOAD_PANELS_FROM_HISTORY(panels));
  }
}

function undoPanelsHistory() {
  const { history } = state();

  if (!DEBUG.enablePanelsUndo || !history.canUndo) {
    return;
  }

  dispatch(UNDO_HISTORY());
  loadPanelsFromCurrentHistoryIndex();
}

function redoPanelsHistory() {
  const { history } = state();

  if (!DEBUG.enablePanelsRedo || !history.canRedo) {
    return;
  }

  dispatch(REDO_HISTORY());
  loadPanelsFromCurrentHistoryIndex();
}

function handleHistoryShortcut(key) {
  if (isEditableElement(key.target) || key.altKey) {
    return;
  }

  const commandPressed = key.ctrlKey || key.metaKey;
  const keyName = key.key && key.key.toLowerCase();
  const isZ = keyName === 'z' || key.keyCode === 90;
  const isY = keyName === 'y' || key.keyCode === 89;

  if (!commandPressed || (!isZ && !isY)) {
    return;
  }

  if (isZ && key.shiftKey) {
    key.preventDefault();
    redoPanelsHistory();
    return;
  }

  if (isZ) {
    key.preventDefault();
    undoPanelsHistory();
    return;
  }

  if (isY) {
    key.preventDefault();
    redoPanelsHistory();
  }
}

function onKeyDown(key) {
  const { rubberBand: { mode }, scale: { enabled }, projectConfiguration: { productId }, advanceRoofSelecting, measurementTool: { enabled : measurementToolenabled} } = state();
  pressedKeys[key.keyCode] = true;
  handleHistoryShortcut(key);

  if (pressedKeys[82] && pressedKeys[16] && mode === 'draw' && !isRMFamily(productId)) {
    dispatch(FLIP_CURSOR());
    dispatch(CHANGE_PANELS_SIZES());
  }

  if (pressedKeys[27] && enabled) {
    trunOffScaleTool();
  }

  if (pressedKeys[27] && measurementToolenabled) {
    dispatch(RESET_CURRENT_MEASUREMENT());
    window.dispatchEvent(new CustomEvent('REFRESH_MEASUREMENT_TOOL'));
  }

  if (pressedKeys[27] && advanceRoofSelecting) {
    deployObstructionDrawing(false);
  }
}

export const arrayDisplacementKeyboard = () => {

  const {panels : {panelsToBeMoved}, background: {moveArrayMode}} = state();
  
  if (moveArrayMode && panelsToBeMoved.length > 0) {
    Events.addEventListener('keyup.panelsDisplacement', (e) => {

      // keycode 13 denotes enter button in keyboard
      if (e.key === "Escape") { 
        dispatch(RESTORE_PANELS_FOR_NO_MOVEMENT());
      }
      else if(e.keyCode === 13){
        e.preventDefault();
        dispatch(RESET_PANELS_ARRAY_FOR_MOVEMENT());
      }

      let code = e.keyCode-37;
      const dirs = [0,1,2,3]
      if (dirs.includes(code)) {
        displacePanels(panelsToBeMoved[0].groupId, code);
      }
    });
  }
  else {
    Events.removeEventListener('keyup.panelsDisplacement');
  }
}
